export default __webpack_public_path__ + "static/media/u_b.89d15480.wav";